module.exports = __webpack_public_path__ + "media/images/producers-c86842d813fd77b26cfef18e60d34b9f.svg";